<template>
<div v-if="isLoaded">
    <!-- Headers -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">Pricing Components</div>
            <v-icon class="ml-3" color="blue darken" large @click="openDialog('headers')">mdi-help-circle</v-icon>
            <span v-if="headersHasChanges" class="warn">Changes are not saved!</span>
        </v-card-title>
        <v-card-text class="card">
            <v-row class="header-row">
                <v-col cols="6">Component Name</v-col>
                <v-col cols="3">Shown By Default</v-col>
                <v-col cols="3">Checked By Default</v-col>
            </v-row>
            <v-row class="custom-row">
                <v-col cols="6">Plan Document Maintenance</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.plan_doc_maint.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.plan_doc_maint.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.plan_doc_maint.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row even">
                <v-col cols="6">Audit Fee</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.audit_fee.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.audit_fee.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.audit_fee.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row">
                <v-col cols="6">3(16)</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.three_sixteen.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.three_sixteen.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.three_sixteen.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row even">
                <v-col cols="6">Payroll Integration</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.payroll_integration.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.payroll_integration.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.payroll_integration.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row">
                <v-col cols="6">Payroll Processing</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.payroll_processing.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.payroll_processing.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.payroll_processing.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row even">
                <v-col cols="6">Custom Additions</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.custom_additions.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.custom_additions.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.custom_additions.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row">
                <v-col cols="6">Custom Notes</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.custom_notes.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.custom_notes.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.custom_notes.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row class="custom-row even">
                <v-col cols="6">PBGC</v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.pbgc.is_shown"
                        label="Shown"
                        @change="headersHasChanges = true">
                    </v-checkbox>
                </v-col>
                <v-col cols="3">
                    <v-checkbox class="custom-checkbox"
                        v-model="headers.pbgc.is_checked"
                        label="Checked"
                        @change="headersHasChanges = true"
                        :disabled="!headers.pbgc.is_shown">
                    </v-checkbox>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-col cols="12" class="px-5" style="text-align:end;">
                <span v-if="headersHasChanges" class="warn pr-5">Changes are not saved!</span>
                <v-btn color="primary" dark @click="saveHeaders">Save Changes</v-btn>
            </v-col>
        </v-card-actions>
    </v-card>

    <!-- Standard Selections -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">Standard Options</div>
            <v-icon class="ml-3" color="blue darken" large @click="openDialog('standard')">mdi-help-circle</v-icon>
            <span v-if="standardOptionsHasChanges" class="warn">Changes are not saved!</span>
        </v-card-title>
        <v-card-text class="card">
            <v-row class="header-row">
                <v-col cols="4"></v-col>
                <v-col cols="2">Takeover</v-col>
                <v-col cols="2">Startup <span style="font-size:14px">(Safe Harbor)</span></v-col>
                <v-col cols="2">Startup <span style="font-size:14px">(Non-Safe Harbor)</span></v-col>
                <v-col cols="2">Cash Balance Only</v-col>
            </v-row>
            <div class="container">
                <v-row class="custom-row">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Standard Fees
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('standard_fees')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Design - Installation Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.standard_fees.design_installation.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.standard_fees.design_installation.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.standard_fees.design_installation.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.standard_fees.design_installation.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Install Participant Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.standard_fees.install_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.standard_fees.install_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.standard_fees.install_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.standard_fees.install_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Annual Participant Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.standard_fees.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.standard_fees.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.standard_fees.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.standard_fees.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Annual Admin Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.standard_fees.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.standard_fees.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.standard_fees.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.standard_fees.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Design & Document Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.standard_fees.document.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.standard_fees.document.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.standard_fees.document.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.standard_fees.document.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row even">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Plan Document Maintenance
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('plan_doc_maint')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.plan_doc_maint.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.plan_doc_maint.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.plan_doc_maint.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.plan_doc_maint.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Audit Fee
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('audit_fee')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.audit_fee.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.audit_fee.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.audit_fee.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.audit_fee.fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row even">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">3(16)
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('three_sixteen')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Setup and Install Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.three_sixteen.setup_install.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.three_sixteen.setup_install.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.three_sixteen.setup_install.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.three_sixteen.setup_install.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Base Annual Admin Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.three_sixteen.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.three_sixteen.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.three_sixteen.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.three_sixteen.annual_admin.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Annual Fees Per Participant</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.three_sixteen.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.three_sixteen.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.three_sixteen.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.three_sixteen.annual_participant.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4">
                                <v-checkbox class="custom-checkbox"
                                    v-model="takeover.three_sixteen.use_basis_points.value"
                                    label="Use Basis Points"
                                    @change="standardOptionsHasChanges = true">
                                </v-checkbox>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.three_sixteen.basis_points.value"
                                v-mask="numMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.three_sixteen.basis_points.value"
                                v-mask="numMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.three_sixteen.basis_points.value"
                                v-mask="numMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.three_sixteen.basis_points.value"
                                v-mask="numMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Payroll Integration
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('payroll_integration')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Base Fee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.payroll_integration.pi_base_fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.payroll_integration.pi_base_fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.payroll_integration.pi_base_fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.payroll_integration.pi_base_fee.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr"></div>
                        <v-row>
                            <v-col cols="4" class="pl-5">Per Employee</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.payroll_integration.pi_per_emp.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.payroll_integration.pi_per_emp.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.payroll_integration.pi_per_emp.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.payroll_integration.pi_per_emp.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row even">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Payroll Processing
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('payroll_processing')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Per Payroll</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.payroll_processing.unit_price.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.payroll_processing.unit_price.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.payroll_processing.unit_price.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.payroll_processing.unit_price.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Custom Additions
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('custom_additions')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-row class="pl-3 pr-4">
                                    <v-checkbox class="custom-checkbox"
                                        v-model="takeover.custom_additions.groups[0].is_checked.value"
                                        @change="standardOptionsHasChanges = true">
                                    </v-checkbox>
                                    <v-text-field class="custom-text-field-row-header"
                                    label="Description"
                                    v-model="takeover.custom_additions.groups[0].description.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>
                        
                                </v-row>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.custom_additions.groups[0].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.custom_additions.groups[0].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.custom_additions.groups[0].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.custom_additions.groups[0].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr" style="margin:-15px 0 10px 0;"></div>
                        <v-row>
                            <v-col cols="4">
                                <v-row class="pl-3 pr-4">
                                    <v-checkbox class="custom-checkbox"
                                        v-model="takeover.custom_additions.groups[1].is_checked.value"
                                        @change="standardOptionsHasChanges = true">
                                    </v-checkbox>
                                    <v-text-field class="custom-text-field-row-header"
                                    label="Description"
                                    v-model="takeover.custom_additions.groups[1].description.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>                  
                                </v-row>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.custom_additions.groups[1].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.custom_additions.groups[1].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.custom_additions.groups[1].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.custom_additions.groups[1].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="custom-hr" style="margin:-15px 0 10px 0;"></div>
                        <v-row>
                            <v-col cols="4">
                                <v-row class="pl-3 pr-4">
                                    <v-checkbox class="custom-checkbox"
                                        v-model="takeover.custom_additions.groups[2].is_checked.value"
                                        @change="standardOptionsHasChanges = true">
                                    </v-checkbox>
                                    <v-text-field class="custom-text-field-row-header"
                                    label="Description"
                                    v-model="takeover.custom_additions.groups[2].description.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>                      
                                </v-row>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.custom_additions.groups[2].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.custom_additions.groups[2].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.custom_additions.groups[2].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.custom_additions.groups[2].value.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="custom-row even">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">Custom Notes
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('payroll_notes')">mdi-help-circle</v-icon>
                                <v-icon class="ml-3" color="blue darken" medium @click="addCustomNote">mdi-plus-circle</v-icon>
                            </v-col>
                        </v-row>
                        <div v-for="(customGroup, index) in takeover.custom_notes.groups" :key="index">
                            <v-row>
                                <v-col cols="4" >
                                    <v-row class="pl-3 pr-4">
                                        <v-checkbox class="custom-checkbox"
                                            v-model="takeover.custom_notes.groups[index].is_checked.value"
                                            @change="standardOptionsHasChanges = true">
                                        </v-checkbox>
                                        <v-icon class="align-start mr-2" color="red darken" medium @click="openDeletDialog(customGroup.custom_group)">mdi-delete-circle</v-icon>
                                        <v-text-field class="custom-text-field-row-header"
                                        label="Description"
                                        v-model="takeover.custom_notes.groups[index].description.value"
                                        @change="standardOptionsHasChanges = true">
                                        </v-text-field>                           
                                    </v-row>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field class="custom-text-field"
                                    v-model="takeover.custom_notes.groups[index].value.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>                    
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field class="custom-text-field"
                                    v-model="startup_sh.custom_notes.groups[index].value.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>                       
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field class="custom-text-field"
                                    v-model="startup_nsh.custom_notes.groups[index].value.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>                      
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field class="custom-text-field"
                                    v-model="cashbalance.custom_notes.groups[index].value.value"
                                    @change="standardOptionsHasChanges = true">
                                    </v-text-field>                       
                                </v-col>
                            </v-row>
                            <div class="custom-hr" style="margin:-15px 0 10px 0;"></div>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="custom-row">
                    <v-col cols="12">
                        <v-row class="sub-header-row">
                            <v-col cols="12">BPGC
                                <v-icon class="ml-3" color="blue darken" medium @click="openDialog('pbgc')">mdi-help-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" class="pl-5">Premium Filing</v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="takeover.pbgc.premium_filing.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_sh.pbgc.premium_filing.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="startup_nsh.pbgc.premium_filing.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="custom-text-field"
                                v-model="cashbalance.pbgc.premium_filing.value"
                                v-mask="curreMask"
                                @change="standardOptionsHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-col cols="12" class="px-5" style="text-align:end;">
                <span v-if="standardOptionsHasChanges" class="warn pr-5">Changes are not saved!</span>
                <v-btn color="primary" dark @click="saveSelections">Save Changes</v-btn>
            </v-col>
        </v-card-actions>
    </v-card>
    
    <div style="min-height:200px;"></div>

    <!-- Help Dialog -->
    <v-dialog v-model="dialog.show" max-width="650px">
        <v-card>
            <v-card-title>
                <div class="text-h4 primary--text font-weight-light">
                {{dialog.title}}
                </div>
            </v-card-title>
            <v-card-text>
                <v-col cols="12">
                    <v-row v-for="p in dialog.paragraphs" :key="p.id" class="mb-5" style="font-size:18px;">
                    {{p}}
                    </v-row>
                </v-col>
            </v-card-text>
            <v-card-actions>
                <v-col cols="12" class="px-5" style="text-align:end;">
                    <v-btn @click="dialog.show = false">Close</v-btn>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog.show" max-width="650px">
        <v-card>
            <v-card-title>
                <div class="text-h4 primary--text font-weight-light">
                {{deleteDialog.title}}
                </div>
            </v-card-title>
            <v-card-text>
                <v-col cols="12">
                    <v-row class="mb-5" style="font-size:18px;">
                    {{deleteDialog.text}}
                    </v-row>
                </v-col>
            </v-card-text>
            <v-card-actions>
                <v-col cols="12" class="px-5" style="text-align:end;">
                    <v-btn color="primary" @click="deleteDialog.show = false">Close</v-btn>
                    <v-btn color="error" class="ml-2" @click="handleRemoveCustomNote(deleteDialog.itemToDelete)">Yes</v-btn>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
<div v-else class="text-center pt-5">
    <v-progress-circular indeterminate color="primary" :size="90"></v-progress-circular>
</div>
  
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { ProposalPricingSection, ProposalPricingDefaultOptions } from '@/store/modules/dataModels.js';
import { CustomGroup } from '@/store/modules/proposalBuilderSections.js';
import { getAuthHeader } from '@/store/global_helpers/authHeader.js';
import { getTPAID } from '@/store/global_helpers/sessionReturn.js';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'; 
const currencyMask = createNumberMask({ prefix: '$', allowDecimal: true, includeThousandsSeparator: true, allowNegative: false, });
const numberMask = createNumberMask({ prefix: '', allowDecimal: false, includeThousandsSeparator: true, allowNegative: false, });

export default {
    data: () => ({
        curreMask: currencyMask,
        numMask: numberMask,
        tpa_id: null,
        dialog: {
            show: false,
            title: "",
            paragraphs: []
        },
        headers: {
            // The visibility for these headers can not be customized
            // because their visibility is controled by the Type section
            // of the proposal builder.
            pricing_assumptions: new ProposalPricingSection(),
            mep_pricing: new ProposalPricingSection(),
            standard_fees: new ProposalPricingSection(),

            // These header's visibility can be customized.
            plan_doc_maint: new ProposalPricingSection(),
            audit_fee: new ProposalPricingSection(),
            three_sixteen: new ProposalPricingSection(),            
            payroll_integration: new ProposalPricingSection(),
            payroll_processing: new ProposalPricingSection(),
            custom_additions: new ProposalPricingSection(),
            custom_notes: new ProposalPricingSection(),
            pbgc: new ProposalPricingSection(),
        },
        deleteDialog:{
            show: false,
            title: 'Delete Note',
            text: 'Are you sure you want to delete the note?',
            itemToDelete: '',
        },
        isLoaded: false,
        

        headersHasChanges: false,
        standardOptionsHasChanges: false,
        customAdditionsHasChanges: false,
        customNotesHasChanges: false,
    }),

    mounted() {
        window.scrollTo(0, 0)    
        this.tpa_id = getTPAID();
        this.authHeader = getAuthHeader();
        this.takeover.reset()
        this.startup_sh.reset()
        this.startup_nsh.reset()
        this.cashbalance.reset()
        this.getHeaders();
        this.getSelections();
    },

    computed: {
        ...mapGetters({ 
            takeover: "getTakeover",
            startup_sh: "getStartup_sh",
            startup_nsh: "getStartup_nsh",
            cashbalance: "getCashbalance"
        }),
    },

    watch: {
        "headers.plan_doc_maint.is_shown"(){
            if (!this.headers.plan_doc_maint.is_shown) {
                this.headers.plan_doc_maint.is_checked = false;
            }
        },
        "headers.audit_fee.is_shown"(){
            if (!this.headers.audit_fee.is_shown) {
                this.headers.audit_fee.is_checked = false;
            }
        },
        "headers.three_sixteen.is_shown"(){
            if (!this.headers.three_sixteen.is_shown) {
                this.headers.three_sixteen.is_checked = false;
            }
        },
        "headers.payroll_integration.is_shown"(){
            if (!this.headers.payroll_integration.is_shown) {
                this.headers.payroll_integration.is_checked = false;
            }
        },
        "headers.payroll_processing.is_shown"(){
            if (!this.headers.payroll_processing.is_shown) {
                this.headers.payroll_processing.is_checked = false;
            }
        },
        "headers.custom_additions.is_shown"(){
            if (!this.headers.custom_additions.is_shown) {
                this.headers.custom_additions.is_checked = false;
            }
        },
        "headers.custom_notes.is_shown"(){
            if (!this.headers.custom_notes.is_shown) {
                this.headers.custom_notes.is_checked = false;
            }
        },
        "headers.pbgc.is_shown"(){
            if (!this.headers.pbgc.is_shown) {
                this.headers.pbgc.is_checked = false;
            }
        },
    },

    methods: {
        ...mapActions([
             'raiseMessage'
            ]),

        openDialog(type){
            switch(type){
                case 'headers':
                    this.dialog.title = "Pricing Components";
                    this.dialog.paragraphs = ["The Pricing section of the proposal builder is comprised of multiple components. While they are always available to use, they do not have to be shown by default. This feature allows you to preset the appearance of the Pricing section when using the Proposal Builder.",
                        "E.G. If your company does not usually offer Payroll Integration, you can uncheck 'Shown' and it will not show up in the form. You can still use the Other Pricing Components button to gain access to this component should you have a client that you need it for.",
                        "In all cases, while using the proposal builder form, unchecking a component will result in it not being calculated and added to the setup or annual fee schedule."];
                    break;
                case 'standard':
                    this.dialog.title = "Standard Options";
                    this.dialog.paragraphs = ["For each of the pricing items in the Standard Options you can enter your default pricing per plan type.",
                        "These items have built in logic based on the type of pricing indicated and will be calculated accordingly.",
                        "Some options have checkboxes which correspond with the proposal builder form checkbox."];
                    break;
                case 'standard_fees':
                    this.dialog.title = "Standard Fees";
                    this.dialog.paragraphs = ["Design - Installation Fee, Install Participant Fee, and Design & Document Fee are added to the initial setup.",
                        "Annual Participant an Annual Admin Fee are added to the annual fee schedule."];
                    break;
                case 'plan_doc_maint':
                    this.dialog.title = "Plan Document Maintenance";
                    this.dialog.paragraphs = ["Plan Document Maintenance Fee is added to the initial setup."];
                    break;
                case 'audit_fee':
                    this.dialog.title = "Audit Fee";
                    this.dialog.paragraphs = ["Audit Fee is added to the initial setup."];
                    break;
                case 'three_sixteen':
                    this.dialog.title = "3(16)";
                    this.dialog.paragraphs = ["This can be calculated either of two ways. You may check 'Use Basis Points' and it will be applied to the annual fee schedule. The formula for applying basis points:",
                        "Plan Assets * ( Basis Points * .0001 )",
                        "Or, you may use the other options for calculating 3(16). Setup and Install Fee is added to the initial setup, Base Annual Admin Fee is added to the annual fee schedule. And, Annual Fees Per Participant are calculated then added to the annual fee schedule. The formula for applying Per Participant:",
                        "Per Participant * Participants (with a balance or eligible)"];
                    break;
                case 'payroll_integration':
                    this.dialog.title = "Payroll Integration";
                    this.dialog.paragraphs = ["Payroll Integration Base Fee and the calculated amount are added to the annual fee schedule. The formula for Payroll Integration:",
                    "Number of Payrolls * ( Per Employee * Number of Employees )"];
                    break;
                case 'payroll_processing':
                    this.dialog.title = "Payroll Processing";
                    this.dialog.paragraphs = ["Payroll Processing calculated amount is added to the annual fee schedule. The formula for Payroll Processing:",
                        "Per Payroll * Number of Payrolls"];
                    break;
                case 'custom_additions':
                    this.dialog.title = "Custom Additions";
                    this.dialog.paragraphs = ["In addition to the Standard Options, you may enter up to three custom additions and their respective value per plan type",
                        "When checked, these items are added to the set up fee. If you leave the checkbox unchecked, the amount will not be added."];
                    break;
                case 'custom_notes':
                    this.dialog.title = "Custom Notes";
                    this.dialog.paragraphs = ["You may also enter up to three custom notes and their value per plan type.",
                        "These items are not added to the totals and can be non-numeric","E.G. 'Electronic Filing: $40-$50'"];
                    break;
                case 'pbgc':
                    this.dialog.title = "Pension Benefit Guaranty Corporation (PBGC)";
                    this.dialog.paragraphs = ["Premium Filing Fee and the calculated participant fees are added to the annual fee schedule. The formula for participant fees:",
                        "Participants with a Balance * "];
                    break;
            }
            this.dialog.show = true;
        },
        
        openDeletDialog(itemToDelete){
            this.deleteDialog.show = true
            this.deleteDialog.itemToDelete = itemToDelete
        },
        async getHeaders(){
            axios.get("/pricing_default/manage/headers/?entity_type=tpa&entity_id="+this.tpa_id, this.authHeader)
            .then((res) => {
                res.data.forEach((sec) => {
                    this.headers[sec.section_name] = new ProposalPricingSection(sec)
                })
            })
            .catch((err) => {
                console.log(err);
                this.raiseMessage('There was an error loading your pricing components.');
            })
        },

        async saveHeaders() {
            let headerNames = ["pricing_assumptions","mep_pricing","standard_fees","plan_doc_maint","audit_fee","three_sixteen","payroll_integration","payroll_processing","custom_additions","custom_notes","pbgc"];
            let objList = []
            headerNames.forEach((hdr) => {
                objList.push({
                    entity_type:'tpa',
                    entity_id:this.tpa_id,
                    section_name:hdr,
                    is_shown:this.headers[hdr].is_shown,
                    is_checked:this.headers[hdr].is_checked,
                    custom_groups:this.headers[hdr].custom_groups,
                })
            })
            axios.post("/pricing_default/manage/headers/", {headers:objList}, this.authHeader)
            .then(() => {
                this.headersHasChanges = false
                this.raiseMessage('Successfully saved your pricing component defaults!')
            })
            .catch((err) => {
                console.log(err);
                this.raiseMessage('There was an error saving your pricing component defaults!')
            });
        },

        async getSelections(){
            axios.get("/pricing_default/manage/selections/?entity_type=tpa&entity_id="+this.tpa_id, this.authHeader)
            .then((res) => {
                this.takeover.loadData(res.data.takeover);
                this.startup_sh.loadData(res.data.startup_sh);
                this.startup_nsh.loadData(res.data.startup_nsh);
                this.cashbalance.loadData(res.data.cashbalance);
                this.isLoaded = true
            })
            .catch((err) => {
                console.log(err);
                this.raiseMessage('There was an error loading your pricing.');  
            })
        },

        async saveSelections(){
            this.standardOptionsHasChanges = false;
            this.customAdditionsHasChanges = false;
            this.customNotesHasChanges = false;
            this.duplicateSpecialFields();
            let details = this.getDetailsFromPricingSections();
            let schema = this.getSchemaFromDetails(details);
            let options = this.getOptionsFromDetailsAndSchema(details,schema);
            let obj = {
                entity_type: 'tpa',
                entity_id: this.tpa_id,
                options: options,
                selections: details,
            }

            axios.post("/pricing_default/manage/selections/", obj, this.authHeader)
            .then(() => {
                this.raiseMessage('Successfully saved your pricing.');
                this.isLoaded = false
                this.getSelections();
            })
            .catch((err) => {
                console.log(err);
                this.raiseMessage('There was an error saving your pricing.');
            })
        },

        duplicateSpecialFields(){
            // console.log("duplicateSpecialFields")
            // console.log(this.takeover)
            this.startup_sh.three_sixteen.use_basis_points.value = this.takeover.three_sixteen.use_basis_points.value;
            this.startup_nsh.three_sixteen.use_basis_points.value = this.takeover.three_sixteen.use_basis_points.value;
            this.cashbalance.three_sixteen.use_basis_points.value = this.takeover.three_sixteen.use_basis_points.value;

            let groupCount = this.takeover.custom_additions.groups.length;
            for (let i = 0; i < groupCount; i++){
                let chk = this.takeover.custom_additions.groups[i].is_checked.value
                let des = this.takeover.custom_additions.groups[i].description.value

                this.startup_sh.custom_additions.groups[i].is_checked.value = chk;
                this.startup_nsh.custom_additions.groups[i].is_checked.value = chk;
                this.cashbalance.custom_additions.groups[i].is_checked.value = chk;

                this.startup_sh.custom_additions.groups[i].description.value = des;
                this.startup_nsh.custom_additions.groups[i].description.value = des;
                this.cashbalance.custom_additions.groups[i].description.value = des;
            }

            groupCount = this.takeover.custom_notes.groups.length;
            for (let i = 0; i < groupCount; i++){
                let chk = this.takeover.custom_notes.groups[i].is_checked.value
                let des = this.takeover.custom_notes.groups[i].description.value

                this.startup_sh.custom_notes.groups[i].is_checked.value = chk;
                this.startup_nsh.custom_notes.groups[i].is_checked.value = chk;
                this.cashbalance.custom_notes.groups[i].is_checked.value = chk;

                this.startup_sh.custom_notes.groups[i].description.value = des;
                this.startup_nsh.custom_notes.groups[i].description.value = des;
                this.cashbalance.custom_notes.groups[i].description.value = des;
            }
        },

        addCustomNote(){
            let group = {
                'custom_group': `${this.takeover.custom_notes.groups.length + 1}`,
                'is_checked': false,
                'description': "",
                'value': "",
            }
            this.takeover.custom_notes.groups.push(new CustomGroup(group))
            this.startup_sh.custom_notes.groups.push(new CustomGroup(group))
            this.startup_nsh.custom_notes.groups.push(new CustomGroup(group))
            this.cashbalance.custom_notes.groups.push(new CustomGroup(group))
        },
        handleRemoveCustomNote(customGroupToDelete){
            this.removeCustomNote(customGroupToDelete)
            this.deleteDialog.show = false
        },
        removeCustomNote(customGroupToDelete){
            let typePlans = [this.takeover, this.startup_sh, this.startup_nsh, this.cashbalance]
            typePlans.forEach(plan =>{
                let updatedCustomGroup =[]
                let filteredplan = plan.custom_notes.groups.filter((group) => group.custom_group !== customGroupToDelete)
                filteredplan.forEach((group, index)=>{
                    const newCustomGroupNumber = `${index + 1}`
                    let updatedGroup = {
                        'custom_group': newCustomGroupNumber,
                        'is_checked': group.is_checked,
                        'description': group.description,
                        'value': group.value,
                    }
                    updatedGroup.is_checked.custom_group = newCustomGroupNumber
                    updatedGroup.description.custom_group = newCustomGroupNumber
                    updatedGroup.value.custom_group = newCustomGroupNumber
                    updatedCustomGroup.push(new CustomGroup(updatedGroup))
                })
                plan.custom_notes.groups = updatedCustomGroup
            })
        },
        getDetailsFromPricingSections(){
            let details = [];
            let sections = [[this.takeover,'takeover'],[this.startup_sh,'startup-sh'],[this.startup_nsh,'startup-nsh'],[this.cashbalance,'cashbalance']];
            sections.forEach((sec) => {
                sec[0].detailsForDefaults(sec[1]).forEach((d) => { details.push(d) })
            })
            return details;
        },

        getSchemaFromDetails(details){
            let schema = [];
            let sections = [];
            details.forEach((d) => {
                if (!sections.includes(d.section_name)) {
                    sections.push(d.section_name)
                }
            })
            sections.forEach((sec) => { schema.push([sec,[]]) })
            schema.forEach((sec) => {
                details.forEach((d) => {
                    if (d.section_name == sec[0]){
                        if (!sec[1].includes(d.detail_name)){
                            sec[1].push(d.detail_name)
                        }
                    }
                })
            })
            return schema;
        },

        getOptionsFromDetailsAndSchema(details,schema){
            let options = [];
            schema.forEach((sec) => {
                let secDetails = [];
                let customGroups = [];
                details.forEach((d) => {
                    if (d.section_name === sec[0]){
                        secDetails.push(d);
                        if (d.custom_group !== null){
                            if (!customGroups.includes(d.custom_group)){
                                customGroups.push(d.custom_group)
                            }
                        }
                    }
                })
                sec[1].forEach((detailName) => {
                    if (customGroups.length > 0) {
                        customGroups.forEach((group) => {
                            let uniqueValues = [];
                            secDetails.forEach((det) => {
                                if (det.detail_name === detailName && det.custom_group === group){
                                    if (!uniqueValues.includes(det.value) && det.value !== null){
                                        uniqueValues.push(det.value)
                                    }
                                }
                            })
                            uniqueValues.forEach((val) => {
                                options.push(
                                new ProposalPricingDefaultOptions({
                                        section_name: sec[0],
                                        detail_name: detailName,
                                        custom_group: group,
                                        value: val,
                                    })
                                )
                            })
                        })
                    } else {
                        let uniqueValues = [];
                        secDetails.forEach((det) => {
                            if (det.detail_name === detailName){
                                if (!uniqueValues.includes(det.value) && det.value !== null){
                                    uniqueValues.push(det.value)
                                }
                            }
                        })
                        uniqueValues.forEach((val) => {options.push(
                            new ProposalPricingDefaultOptions({
                                    section_name: sec[0],
                                    detail_name: detailName,
                                    custom_group: null,
                                    value: val,
                                })
                            )
                        })
                    }
                })
            })
            return options;
        },
    },
};
</script>

<style scoped>

.card {
    overflow-y:hidden;
    overflow-x:auto;
}

.custom-row {
    font-size: 18px;
    border: 1px solid #DDD;
}

.header-row {
    background: #DDD;
    font-size: 24px;
    border-radius: 8px 4px 0 0;
}

.sub-header-row {
    margin-top: -10px;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 20px;
    color: #444;
}

.custom-hr {
    border-bottom: dashed 1px #DDD;
    margin-left: 10px;
}

.even {
    background: #EFEFEF
}

.custom-checkbox {
    max-height:20px;
    margin-top:-5px;
    padding-bottom:5px;
}

.custom-text-field {
    max-height:20px;
    margin-top:-20px;
    padding-right: 20px;
}

.container {
    max-height: 600px;
    overflow-y: scroll;
}

.custom-text-field-row-header {
    max-height:60px;
    margin-top:-20px;
    padding-right: 20px;
}

.warn {
    padding-left: 10px;
    font-size: 16px;
    color: rgb(250, 100, 50);
    font-weight: 700;
}

</style>
